import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CustomTable from '../../components/Table/Table';
import GridItem from '../../components/Grid/GridItem';
import Pagination from '../../components/Pagination/Pagination';
import DialogEditLiveStreamOrganizer from '../../containers/LiveStreamOrganizer/DialogEditLiveStreamOrganizer';
import { Create, PreviewIcon } from '../../components/Icons/Icon';
import Loader from '../../components/Loader/Loader';
import DialogDetailLiveStreamOrganizer from '../../containers/LiveStreamOrganizer/DialogDetailLiveStreamOrganizer';
import ViewHeader from '../../components/Header/ViewHeader';
import { Role } from '../../common/Constants';
import Typography from '../../components/Typography/CustomTypography';
import CustomTextSelector from '../../selectors/CustomText';
import styles from '../../assets/jss/pages/productManagementPageStyle';

const useStyles = makeStyles(styles);

export const Header = (props) => {
    const { role, eventInfo } = props;
    const [title, setTitle] = useState('ライブ配信');

    useEffect(() => {
        switch (role) {
            case Role.viewer:
                setTitle('ライブ配信');
                break;

            case Role.organizer:
                setTitle('ライブ配信');
                break;

            default:
                setTitle('ライブ配信');
                break;
        }
    }, [role]);

    return (
        <ViewHeader
            eventName={eventInfo.name}
            title={title}
        />
    );
};

Header.defaultProps = {
    role: NaN,
    eventInfo: {},
};

Header.propTypes = {
    role: PropTypes.number,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const ListLiveStreamOrganizer = (props) => {
    const {
        isLoading,
        listEvent,
        currentPage,
        totalPage,
        fetchGetListLiveStream,
        fetchClearGetListLiveStream,
    } = props;

    const routeParams = useParams();
    const intl = useIntl();
    const classes = useStyles();

    const [listEventLiveStream, setListEventLiveStream] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [liveStreamId, setLiveStreamId] = useState(null);
    const [isOpenDialogDetail, setIsOpenDialogDetail] = useState(false);
    const customText = useSelector(CustomTextSelector.createGetCustomText());
    const customTextSidebar = useSelector(CustomTextSelector.createGetCustomTextSidebarOrganizer());
    const history = useHistory();

    useEffect(() => {
        fetchClearGetListLiveStream();
        return () => {
            fetchClearGetListLiveStream();
        };
    }, []);

    useEffect(() => {
        if (routeParams) {
            fetchGetListLiveStream({ event_name: routeParams.shortName });
        }
    }, [routeParams]);

    useEffect(() => {
        if (!isOpenDialog) {
            fetchGetListLiveStream({ event_name: routeParams.shortName });
        }
    }, [isOpenDialog]);

    useEffect(() => {
        if (!isOpenDialogDetail) {
            fetchGetListLiveStream({ event_name: routeParams.shortName });
        }
    }, [isOpenDialogDetail]);

    useEffect(() => {
        if (!_.isEmpty(listEvent)) {
            const tableData = listEvent.map((event) => {
                const disabled = event.content && event.limit;
                return (
                    [
                        event.title,
                        event.speaker,
                        `${event.stime} ~ ${event.etime}`,
                        (event.dates).map((date) => <p>{[date.date.slice(0, 4), '/', date.date.slice(5, 7), '/', date.date.slice(8, 10)].join('')}</p>),
                        event.cost === 0 ? '無料' : `${intl.formatNumber(event.cost)}円`,
                        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                            <IconButton onClick={(e) => onViewLiveStream(e, event.id)}>
                                <Create />
                            </IconButton>
                            <IconButton onClick={(e) => handlePreview(e, event.id, disabled)} className={!disabled && classes.disableHover} disableRipple={!disabled}>
                                <PreviewIcon color={(!disabled) && 'rgba(0, 0, 0, 0.26)'} />
                            </IconButton>
                        </Box>,
                    ]
                );
            });
            setListEventLiveStream(tableData);
        }
    }, [listEvent]);

    const handlePreview = (e, id, disabled) => {
        e.stopPropagation();
        if (disabled) {
            const { shortName } = routeParams;
            const path = `/${shortName}/livestream-management/${id}?is_preview=true`;
            history.push(path);
        }
    };

    const handleSearchWithPage = (page) => {
        fetchGetListLiveStream({ event_name: routeParams.shortName, page });
    };

    const onViewLiveStream = (e, id) => {
        e.stopPropagation();
        setLiveStreamId(id);
        setIsOpenDialog(true);
    };

    const handleShowEventDetail = (index) => {
        setLiveStreamId(listEvent[index].id);
        setIsOpenDialogDetail(true);
    };

    const createTable = () => {
        const tableHeaders = [
            <>{customText?.content?.field_name?.title || 'タイトル'}</>,
            <>{customText?.content?.field_name?.performer || '出演者'}</>,
            <>{customText?.content?.field_name?.time_zone || '時間帯'}</>,
            <>{customText?.content?.field_name?.dates || '日程'}</>,
            <>{customText?.content?.field_name?.paid_and_free || '有料・無料'}</>,
            <>{customText?.content?.field_name?.action || 'アクション'}</>,
        ];
        const tableHeaderWidth = ['30%', '17%', '17%', '15%', '11%', '10%'];
        return (
            <CustomTable
                onClick={(index) => handleShowEventDetail(index)}
                tableHead={tableHeaders}
                tableHeadWidth={tableHeaderWidth}
                tableData={listEventLiveStream}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={currentPage}
                            total={totalPage}
                            onChange={(page) => handleSearchWithPage(page)}
                        />
                    </Box>
                )}
            />
        );
    };

    return (
        <>
            <GridItem xs={12}>
                <Box paddingBottom={4} paddingTop={4}>
                    <Typography bold variant="h4" color="info" align="center">
                        {customTextSidebar?.field_name?.livestreaming_info_management || 'ライブ配信情報管理'}
                    </Typography>
                </Box>
                {createTable()}
            </GridItem>
            <DialogEditLiveStreamOrganizer
                isOpen={isOpenDialog}
                handleIsClose={() => setIsOpenDialog(false)}
                liveStreamId={liveStreamId}
                eventName={routeParams.shortName}
            />
            <DialogDetailLiveStreamOrganizer
                isOpen={isOpenDialogDetail}
                handleClose={() => setIsOpenDialogDetail(false)}
                detailLiveStreamId={liveStreamId}
                eventName={routeParams.shortName}
                handleOpenEdit={() => {
                    setIsOpenDialog(true);
                    setIsOpenDialogDetail(false);
                }}
            />
            <Loader isLoading={isLoading} />
        </>
    );
};

ListLiveStreamOrganizer.defaultProps = {
    listEvent: { },
    currentPage: null,
    totalPage: null,
    fetchGetListLiveStream: () => {},
    fetchClearGetListLiveStream: () => {},
};

ListLiveStreamOrganizer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    currentPage: PropTypes.number,
    totalPage: PropTypes.number,
    listEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchGetListLiveStream: PropTypes.func,
    fetchClearGetListLiveStream: PropTypes.func,
};

export default ListLiveStreamOrganizer;
